import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";

import { i18n } from "@/i18n";

const { t } = i18n.global;

const UpsellAccessRequest = z.object({
  dictionaryId: z.string(),
  dictionaryTitle: z.string(),
  name: z
    .string({
      required_error: t("validation.required")
    })
    .max(255, { message: t("validation.max", { max: 255 }) })
    .nonempty({ message: t("validation.required") }),
  email: z
    .string({
      required_error: t("validation.required")
    })
    .max(255, { message: t("validation.max", { max: 255 }) })
    .nonempty({ message: t("validation.required") })
    .email(t("validation.email")),
  phone: z
    .union([
      z
        .string()
        .min(8, { message: t("validation.min", { min: 8 }) })
        .max(20, { message: t("validation.max", { max: 20 }) }),
      z.string().length(0) // Allow empty string without clashing with min/max
    ])
    .optional(),
  comment: z
    .string()
    .max(1000, { message: t("validation.max", { max: 1000 }) })
    .optional(),
  acceptMarketing: z.boolean()
});

export type UpsellAccessRequest = z.infer<typeof UpsellAccessRequest>;

export const upsellAccessRequestFormValidator = toTypedSchema(UpsellAccessRequest);
